angular.module("dettaglioCruscottoRichiestaClientiARU.components", [])
  .component("dettaglioCruscottoRichiestaClientiAru", {
    templateUrl: "ng/components/cruscottoRichiestaClienti/dettaglioCruscottoRichiestaClientiARU/dettaglioCruscottoRichiestaClientiARU.view.html",
    bindings: {
      richiestePostVendita: "=",
      portal: "="
    },
    controllerAs: "dettaglioCruscottoRichiestaClientiCtrl",
    controller: function DettaglioCruscottoRichiestaClientiCtrl(
      FileUploader,
      $location,
      $financialApiService,
      $arcService,
      $configService,
      $simulationService,
      $rootScope,
      $timeout,
      $typeDomainService,
      $portalService,
      $download
    ) {
      var self = this;

      self.$onInit = function () {
        self.$portalService = $portalService;
        self.supportModel = {
          replyMessage: "",
          categoriaSelezionata: undefined,
          listaCategorie: undefined,
          tipoRichiestaSelezionata: undefined,
          listaTipoRichiesta: undefined,
          documentUpload: [],
          loadingStatus: {
            uploading: false,
            loading: false
          },
          sospendiIsEnabled: false,
          checkboxEmailSeparata: self.richiestePostVendita.metadata.closeOutside,
          ufficioSelezionato: undefined,
          listaUfficio: undefined,
          loaderAggiorna: false,
          loaderChiudi: false,
          loaderRichInf: false
        }
        var alba = self.richiestePostVendita.metadata.attachedDocs
          .map(function (allegato) {
            return {
              id: allegato,
              type: 'ALBA',
              selected: false,
              downloadKey: allegato.downloadKey,
              filename: allegato.filename
            }
          })

        var cli = self.richiestePostVendita.metadata.attachedDocsCli
          .map(function (allegato) {
            return {
              id: allegato,
              type: 'CLI',
              selected: false,
              downloadKey: allegato.downloadKey,
              filename: allegato.filename
            }
          })

        self.supportModel.documentUpload = alba.concat(cli);
        self.getListaUffici();
      };

      self.handleChange = function (property) {
        switch (property) {
          case 'categoria':
            if (self.supportModel.categoriaSelezionata) {
              self.getDropDownRequestsPv();
              self.richiestePostVendita.type = self.supportModel.categoriaSelezionata.value;
              self.richiestePostVendita.typeDescr = self.supportModel.categoriaSelezionata.name
            }
            self.supportModel.tipoRichiestaSelezionata = undefined;
            break;
          case 'tipoRichiesta':
            if (self.supportModel.tipoRichiestaSelezionata) {
              self.richiestePostVendita.subtype = self.supportModel.tipoRichiestaSelezionata.value;
              self.richiestePostVendita.subtypeDescr = self.supportModel.tipoRichiestaSelezionata.name
            }
            break;
          case 'risposta':
            self.richiestePostVendita.metadata.replyMessage = self.supportModel.replyMessage;
            break;
          case 'ufficio':
            if (self.supportModel.ufficioSelezionato) {
              self.richiestePostVendita.rifOffice = self.supportModel.ufficioSelezionato.description
            }
            self.supportModel.categoriaSelezionata = undefined;
            self.supportModel.tipoRichiestaSelezionata = undefined;
            self.getDropDownRequestsPv();
          default:
            break;
        }

        if (property === 'categoria' ||
          property === 'tipoRichiesta' ||
          property === 'risposta') {
          self.supportModel.sospendiIsEnabled = true;
        }
      }

      self.checkCheckbox = function (el) {
        el.checkboxEmailSeparata = !el.checkboxEmailSeparata;
        self.richiestePostVendita.metadata.closeOutside = el.checkboxEmailSeparata;
      }

      self.getDropDownRequestsPv = function () {
        var level = self.supportModel.categoriaSelezionata ? 1 : 0;
        var ufficio = self.supportModel.ufficioSelezionato ? self.supportModel.ufficioSelezionato.name : undefined;

        $arcService.getDropDownRequestsPv(
            level,
            'RICHIESTE_POSTVENDITA',
            self.supportModel.categoriaSelezionata,
            true,
            ufficio
          )
          .then(function (response) {
            if (!self.supportModel.categoriaSelezionata) {
              self.supportModel.listaCategorie = response;

              self.supportModel.listaCategorie.forEach(function (categoria) {
                if (categoria.name === self.richiestePostVendita.typeDescr) {
                  self.supportModel.categoriaSelezionata = categoria;
                  console.log('model: ', self.richiestePostVendita.metadata)
                  self.getDropDownRequestsPv();
                }
              })
            } else {
              self.supportModel.listaTipoRichiesta = response;
              self.supportModel.listaTipoRichiesta.forEach(function (tipoRichiesta) {
                if (tipoRichiesta.name === self.richiestePostVendita.subtypeDescr) {
                  self.supportModel.tipoRichiestaSelezionata = tipoRichiesta
                }
              })
            }
          })
      }

      self.getListaUffici = function () {
        $typeDomainService.getDomainSet('PRACTICE_PV', 'RIF_OFFICE')
          .then(function (response) {
            self.supportModel.listaUfficio = response.domainList;

            self.supportModel.listaUfficio.forEach(function (ufficio) {
              if (ufficio.name === self.richiestePostVendita.rifOffice) {
                self.supportModel.ufficioSelezionato = ufficio;
                self.getDropDownRequestsPv();
              }
            })
          })
      }

      self.indietro = function () {
        localStorage.setItem('isReturnDettaglioCruscotto', true);
        window.history.back();
      }

      self.richiediInformazioni = function () {
        self.supportModel.loaderRichInf = true;
        self.richiestePostVendita.metadata.variazioneAnagrafica = {};
        self.richiestePostVendita.metadata.replyMessage = self.supportModel.replyMessage
        self.richiestePostVendita.richiediInformazioni = true;

        $arcService.aggiornaRichiestaBO(self.richiestePostVendita)
          .then(function (response) {
            self.supportModel.loaderRichInf = false;
            if (response.success) {
              window.history.back();
            }
          })
          .catch(function () {
            self.supportModel.loaderRichInf = false
          })
      }

      self.chiudiTicket = function () {
        self.supportModel.loaderChiudi = true;
        self.richiestePostVendita.metadata.variazioneAnagrafica = {};
        self.richiestePostVendita.metadata.replyMessage = self.supportModel.replyMessage

        $arcService.aggiornaRichiestaBO(self.richiestePostVendita)
          .then(function () {
            self.supportModel.loaderChiudi = false;
            $location.path('/cruscottoRichiestaClienti')
          })
          .catch(function () {
            self.supportModel.loaderChiudi = false
          })
      }

      self.sospendi = function () {
        self.supportModel.loaderAggiorna = true;
        self.richiestePostVendita.metadata.variazioneAnagrafica = {};

        $arcService.sospendiRichiestaBO(self.richiestePostVendita)
          .then(function () {
            self.supportModel.loaderAggiorna = false;
            $location.path('/cruscottoRichiestaClienti')
          })
          .catch(function () {
            self.supportModel.loaderAggiorna = false;
          })
      }

      // funzione che viene chiamata quando clicco su icona upload
      self.uploadDataFunc = function (uploader) {
        var document =
          arguments.length > 3 && arguments[3] !== undefined ?
          arguments[3] :
          false;

        self.uploadDocumenti = document;
        self.uploadFor = uploader
      }

      // istanza di file uploader
      self.uploader = new FileUploader({
        url: "",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
          "App-Name": $rootScope.portalName,
        }
      })

      self.uploader.onAfterAddingFile = function (fileItem) {
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast("addAlert", {
            text: "MAXIMUM_FILE_SIZE_EXCEEDED",
          });
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        if (
          fileName.toLowerCase().indexOf(".pdf") > -1 ||
          fileName.toLowerCase().indexOf(".png") > -1 ||
          fileName.toLowerCase().indexOf(".jpg") > -1 ||
          fileName.toLowerCase().indexOf(".jpeg") > -1 ||
          fileName.toLowerCase().indexOf(".p7m") > -1
        ) {
          self.visualProgBar = true;
          self.uploader.queue[0].progress = 100;

          $timeout(function () {
            self.progresso = 100;
          }, 500);
        } else {
          fileItem.remove();
          $("#input-upload-" + self.currentCodeTypeNameIndex).val("");
          $rootScope.$broadcast("addAlert", {
            text: "FORMAT_NOT_SUPPORTED",
          })
        }
      }

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        self.finalUpload(addedFileItems);
      }

      self.finalUpload = function (file) {
        var url = $configService.getAppConfig().url +
          "/uni/upload/service-infos/POSTVENDITA";
        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.supportModel.loadingStatus.uploading = true;

        var file = document.querySelector("#uploadInput_document").files[0];
        var formData = new FormData();
        var reader = new FileReader();

        reader.onload = function () {
          jQuery("#uploadInput_document").val("");
          appendToForm(formData, "file", file);
          appendToForm(formData, "type", 'RICHIESTE_CLIENTI');
          appendToForm(formData, "cdDoc", 'RICCLI');
          appendToForm(formData, "filename", file.name);
          appendToForm(formData, 'idPratica', self.richiestePostVendita.id);
          appendToForm(formData, 'category', 'RICHIESTE_CLIENTI');
          $financialApiService.uploadDocOnPv(formData)
            .then(function (response) {
              $timeout(function () {
                var temp = {
                  id: response.id,
                  selected: false,
                  type: self.uploadFor,
                  downloadKey: response.downloadKey,
                  filename: response.uploadDoc.docDescription

                }
                if (self.uploadFor == 'CLI') {
                  self.richiestePostVendita.metadata.attachedDocsCli.push(temp);
                } else {
                  self.richiestePostVendita.metadata.attachedDocs.push(temp);
                }
                self.visualProgBar = false;
                self.supportModel.documentUpload.push(temp);
                self.supportModel.sospendiIsEnabled = true;
              }, 4000);
            })
        };
        if (file) {
          reader.readAsArrayBuffer(file);
        }
      }

      self.checkUpload = function (el) {
        el.selected = !el.selected;
      }

      self.trashCanEnabledDoc = function () {
        return self.supportModel.documentUpload.some(function (elem) {
          return elem.selected === true;
        })
      }
      self.downloadFile = function (file) {
        var input = {
          downloadKey: file.downloadKey
        }
        var url = "/uni/downloadDocPv/service-infos/";
        $download.getGenericDownload(url, input)
          .then(function (response) {
            console.log(response)
          })
      }

      self.uploader.onCompleteAll = function () {
        self.uploadCompleted = true;
      }

      // funzione per eliminare un documento
      self.deleteDocument = function (type) {
        self.progresso = 100;
        self.visualProgBar = true;
        $timeout(function () {
          self.progresso = 0;
        }, 200);

        self.documentsToBeDeleted = self.supportModel.documentUpload.filter(function (elem) {
          return elem.selected == true;
        })

        self.documentsToBeDeleted.forEach(function (element) {
          $simulationService.deleteChecklistFilePv(element.id)
            .then(function () {
              $timeout(function () {
                self.visualProgBar = false;
                self.supportModel.documentUpload = self.supportModel.documentUpload
                  .filter(function (e) {
                    return e.selected != true
                  })
                if (type == 'CLI') {
                  self.richiestePostVendita.metadata.attachedDocsCli = self.richiestePostVendita.metadata.attachedDocsCli
                    .filter(function (value) {
                      return value.id != element.id
                    })
                } else {
                  self.richiestePostVendita.metadata.attachedDocs = self.richiestePostVendita.metadata.attachedDocs
                    .filter(function (value) {
                      return value.id != element.id
                    })
                }
                self.supportModel.sospendiIsEnabled = true;
              }, 4000);

            })
            .catch(function () {
              $rootScope.$broadcast('addAlert', {
                text: 'ERROR_TEC'
              });

            })
        })
      }
    }
  })